

















import { Component, Vue } from "vue-property-decorator";
import { syncApi } from "../../services/api/sync.api";
import { State, Action } from "vuex-class";
import QrcodeVue from "qrcode.vue";
import appSnackbarService from "@/services/appSnackbar.service";
import GlobalMixins from "@/global.mixin.ts";
import { ensureHttpsUrl } from "@/utils/ensureHttpsUrl";

@Component({
  mixins: [GlobalMixins],
  components: { QrcodeVue }
})
export default class SyncView extends Vue {

  @Action("configLoad") configLoad: any;
  @Action("configSave") configSave: any;

  serverRunning = false;
  loading = true;
  serverUrl = "";

  qrcode = "Scan this URL";
  qrsize = 400;

  created() {
    this.loading = true;

    syncApi.getIp()
    .then( res => {
      // console.log("url: ", res);
      this.setQrCode(res.data.url);
      this.loading = false;
      this.serverRunning = true;
    })
    .catch( err => {
      // console.log("url: ", err);
      appSnackbarService.error(err);
      this.loading = false;
      this.serverRunning = false;
    });
  }

  setQrCode(url: string) {
    const httpsUrl = ensureHttpsUrl(url);
    this.serverUrl = httpsUrl;
    this.qrcode = JSON.stringify({ qlm_api_url: httpsUrl });
  }
}
